const classPay = {
  path: 'classPay/:orderId',
  props: true,
  component: resolve => require(['../../../../../components/pages/student_user/homeClass/classEnroll/classPay'], resolve)
}
export default classPay



// WEBPACK FOOTER //
// ./src/router/pages/student_user/homeClass/classEnroll/classPay.js